import { useContext } from 'react'
import { ModalFiltersContext } from '../contexts/ModalContext'

export const useModal = () => {
  const context = useContext(ModalFiltersContext)

  return context
}
